import styled from "@emotion/styled";
import {ReactComponent as svg} from "../../../../images/iconMax.svg";

export const MaxSvg = styled(svg)`
    padding-top: 4px;
    width: 28px;
    fill: #0068D1;
`;